import React from "react";
import uuidv4 from 'uuid/v4';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
  }
}));

/**
 * Component for display html string (for example content of WYSIWYG inputs)
 * @name IFrame
 * @param {object} props React component properties
 * @param {string} props.src URL string with
 * @param {string} props.width Width of iframe
 * @param {string} props.height Height of iframe
 * @param {string} [props.className] CSS-class of container
 * @param {string} [props.id] Identifer of iframe
 * @param {string} [props.name] Name of iframe
 * @example
 * return (
 *  <IFrame src = { "https://google.com" }
 *          width = { "100%" }
 *          height = { "340px" } />
 * )
*/

const IFrame =  (props) => {

  const classes = blockStyles();

  const defId = uuidv4();
  const { className, iframeClass } = props;
  const { width, height, src, id = defId, name = defId } = props;

  const modifiedSrc = src.match(/youtube/) ? `${src}?rel=0&modestbranding=1&showinfo=0&controls=0` : src
  const iframe = `<iframe class="${iframeClass}" src="${modifiedSrc}?e=2" width="${width}" height="${height}" id="${id}" name="${name}" frameborder="0" style="border: 0px" allowfullscreen></iframe>`

  return (
    <div className = { clsx(classes.root, className) }>
      <div dangerouslySetInnerHTML={ { __html: iframe } } />
    </div>
  );
}

IFrame.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
};

export default IFrame;
